module.exports = __webpack_public_path__ + "img/DonikaLociWhiteSVG.d69712fa.svg";